import { Section } from '@/modules/articles/model/section';
import axios from 'axios';

// Display-only renames; codes and flags (permissioning) stay as the backend returns them.
const SECTION_NAME_OVERRIDES: Record<string, string> = {
  'us-credit-bullets': 'US IG Credit Bullets',
};

async function getSectionByCode(code: string): Promise<Section> {
  return axios.get<Section>(`/api/v1/news/section/${code}`).then(({ data }) => {
    const name = SECTION_NAME_OVERRIDES[data.code];
    return name ? { ...data, name } : data;
  });
}

const sectionApi = {
  getSectionByCode,
};

export default sectionApi;
